import React from "react"
import { Link } from "gatsby"
import * as Icon from "react-feather"

import Logo from "../../assets/images/logo.png"
import tarkashilpaLogo from "../../assets/images/logo-tarkashilpa.png"
import MapImg from "../../assets/images/map.png"
import Shape1 from "../../assets/images/shape1.png"
import Shape2 from "../../assets/images/shape2.svg"
import NewsLetter from "../newsletter"

const Footer = () => {
  const currentYear = new Date().getFullYear()
  return (
    <>
      <footer className="footer-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-3 col-sm-6">
              <div className="single-footer-widget">
                <div className="logo">
                  <Link to="/">
                    <img src={tarkashilpaLogo} alt="Tarkashilpa - logo" />
                  </Link>
                </div>

                <ul className="social-links mb-4">
                  <li>
                    <a
                      href="https://in.linkedin.com/company/tarkashilpa-technologies"
                      className="linkedin"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Icon.Linkedin />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/tarkashilpa"
                      className="twitter"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Icon.Twitter />
                    </a>
                  </li>
                </ul>

                <div
                  className="clutch-widget"
                  data-nofollow="true"
                  data-url="https://widget.clutch.co"
                  data-widget-type="1"
                  data-darkbg="true"
                  data-height="40"
                  data-clutchcompany-id="1797346"
                  data-primary-color="#85c226"
                  data-secondary-color="#85c226"
                ></div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="single-footer-widget pl-5">
                <h3>Quick Links</h3>
                <ul className="list">
                  <li>
                    <Link to="/services/mobile-app-development/">
                      Mobile App Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/web-app-development/">
                      Web App Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/our-work">Our Work</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6 col-sm-6 col-md-12">
              <div className="single-footer-widget">
                <p>
                  At Tarkashilpa, we are passionate about using technology to
                  solve business challenges and help business grow at scale. We
                  design our apps to meet your business goals and provide the
                  best solution as per your business parameters.
                  <br />
                  <br />
                  We believe in taking ownership of deliveries and taking pride
                  in our creation. We are committed to setting our client’s
                  expectations right upfront at the beginning of the project and
                  providing an honest service to our clients. We like to work
                  towards achieving your business goals as your technology
                  partners whom you can rely on.
                </p>
              </div>
            </div>
          </div>

          <div className="copyright-area">
            <div className="copyright">
              <p>
                Copyright &copy; {currentYear}. All rights reserved by
                Tarkashilpa Technologies
              </p>
            </div>
            <div className="newsletter-area">
              <NewsLetter />
            </div>
          </div>
        </div>

        {/* Shape Images */}
        <div className="shape1">
          <img src={Shape1} alt="shape" />
        </div>
        <div className="shape8 rotateme">
          <img src={Shape2} alt="shape" />
        </div>
      </footer>
      <div className="footer-attributes">
        <div className="container">
          <a
            href="https://www.freepik.com/vectors/menu"
            target="_blank"
            rel="nofollow"
          >
            Menu vector created by freepik - www.freepik.com
          </a>

          <a
            href="https://www.vecteezy.com/free-vector/web-application"
            target="_blank"
            rel="nofollow"
          >
            Web Application Vectors by Vecteezy
          </a>

          <a
            href="https://www.flaticon.com/free-icons/smartphone"
            title="smartphone icons"
            target="_blank"
            rel="nofollow"
          >
            Smartphone icons created by Freepik - Flaticon
          </a>

          <a
            href="https://www.flaticon.com/free-icons/user-interface"
            title="user-interface icons"
            target="_blank"
            rel="nofollow"
          >
            User-interface icons created by Freepik - Flaticon
          </a>

          <a
            href="https://www.freepik.com/vectors/physiotherapy-logo"
            target="_blank"
            rel="nofollow"
          >
            Physiotherapy logo vector created by freepik - www.freepik.com
          </a>
        </div>
      </div>
      <script
        type="text/javascript"
        id="zsiqchat"
        dangerouslySetInnerHTML={{
          __html: `var $zoho=$zoho || {}; var obj = {}; obj.widgetcode =
          "851ce0c43993adec46f8f71da4a66457aa187655b4c0b6fe0f059f00880d60f61a2010ab7b6727677d37b27582c0e9c4"; obj.values = {}; obj.ready = function(){}; $zoho.salesiq = $zoho.salesiq || obj; var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zoho.com/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);`,
        }}
      />

      {/* Development Zoho Chat Icon */}

      {/* <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `var $zoho=$zoho || {}; var obj = {}; obj.widgetcode =
          "1108ee0dab99e28b229809d9611263884301fb8dad897f008a5ed08832fd8f41a2d01e8ccc6c079200f47ed8db9cddc4"; obj.values = {}; obj.ready = function(){}; $zoho.salesiq = $zoho.salesiq || obj; var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zoho.com/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);`,
        }}
        id="zsiqchat"
      ></script> */}
    </>
  )
}

export default Footer
